import { cDateField, cDateFieldPrams } from '../../../components/date-field/date-field';
import {cUtil}                         from './../../../functions/util';

export class cProductItemDeliveryDate implements DateFieldTop  {

  date          : cDateField;
  parentObj     : DateFieldTop;
  isBeyondLimit : boolean;

  constructor(
    item          : OrderListItem,
    product       : ProductData,
    parentElm     : HTMLElement,
    parentObj     : DateFieldTop
  ) {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;

    this.parentObj = parentObj;

    // Private customers: the earliest date lies beyond their limit, show it but the product can't be ordered
    const beyondLimitDate = product.deliveryDates.beyondLimitDate;
    this.isBeyondLimit    = beyondLimitDate !== '';

    const initDate =
      this.isBeyondLimit        ? beyondLimitDate    :
      item.delivery_date !== '' ? item.delivery_date :
      /*else*/ product.deliveryDates.validDates.at(0) ?? ''


    // ---- Structure ----
    const deliveryDateLabel = 
      cUtil.customerPickUp() 
      ? __('Abholdatum', 'custom')
      : __('Lieferdatum', 'custom');

    const deliveryDateParam: cDateFieldPrams = {
      validDates      : this.isBeyondLimit ? [beyondLimitDate] : product.deliveryDates.validDates,
      initDate        : initDate,
      label           : deliveryDateLabel,
      placeholder     : '',
      parentElm       : parentElm, 
      parentObj       : this,
      eventDefault    : 'cProductItemDeliveryDate_constructor_dateFieldDefault',
      cssClass        : 'c-delivery-date',
      emptyAllowed    : false,
    }
    this.date = new cDateField(deliveryDateParam);

    // ---- Init ----
    if (this.isBeyondLimit) {
      this.date.setError(this.beyondLimitMessage());
    }

    // ---- Events ----

  }

  validateItem(silent: 'silent'|'', message: 'list'|'', isSelected: boolean = true): boolean {
    if (!isSelected) return true;
    if (this.isBeyondLimit) {
      this.date.setError(this.beyondLimitMessage());
      return false;
    }
    return this.date.validateItem(silent, message);
  }

  beyondLimitMessage(): string {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;
    return __('Dieses Produkt kann von Privatkunden nicht bestellt werden, da die Vorbestellzeit zu lang ist.', 'custom');
  }

  changeEvent(eventSource: string): void {
    this.parentObj.changeEvent(eventSource);
  }

  getDate(): string {
    return this.date.getDate();
  }
  
  setDate(date: string) {
    this.date.setDate(date);
  }
}
